import TrackingCodeInjector from './TrackingCodeInjector';

export default function GlobalTrackingCodes() {
  return (
    <>
      <TrackingCodeInjector position="head" />
      <TrackingCodeInjector position="body" />
    </>
  );
}